import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { IKnmErknmViolationEvidence } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmViolationEvidence';

export interface IVideoFixationSelectOption extends ISelectOption {
  number?: number;
}

export const getVideoFixationNumber = (index: number): number => index + 1;

export const getVideoFixationSelectOptionLabel = (index: number): string =>
  `Ссылка на видеозапись или фотоматериалы №${getVideoFixationNumber(index)}`;

export const createVideoFixationSelectOptionByGuid = (
  guid: string,
  evidences: Array<{ guid: string | null }> | undefined | null,
): IVideoFixationSelectOption => {
  const index = evidences?.findIndex(item => item.guid === guid) ?? -1;

  return {
    id: guid,
    value: guid,
    number: index >= 0 ? getVideoFixationNumber(index) : undefined,
    label: index >= 0 ? getVideoFixationSelectOptionLabel(index) : 'Ссылка на видеозапись или фотоматериалы',
  };
};

export const createVideoFixationSelectOptions = (
  evidences: IKnmErknmViolationEvidence[] | undefined,
  selectedEventGuid?: string | null,
): IVideoFixationSelectOption[] => {
  if (!evidences?.length) {
    return [];
  }

  return evidences
    .map((item, index) => ({ item, index }))
    .filter(({ item }) => {
      if (!item.guid) {
        return false;
      }

      if (selectedEventGuid && item.eventOption?.value && item.eventOption.value !== selectedEventGuid) {
        return false;
      }

      return true;
    })
    .map(({ item, index }) => ({
      id: item.guid as string,
      value: item.guid as string,
      number: getVideoFixationNumber(index),
      label: getVideoFixationSelectOptionLabel(index),
    }));
};
